import { style } from '@vanilla-extract/css'

const link = style({
  fontSize: '15px',
  lineHeight: '1.5',
  textDecoration: 'underline',
})

export const styles = {
  link,
}
